const PhoneGoWhatsApp = ({ children }) => {

  return (

    <a href={`https://wa.me/${ children }`} target="_blank" rel="noreferrer">

      { children }

    </a>

  )

}

export default PhoneGoWhatsApp;